if (!customElements.get('fuji-filters')) {
  customElements.define('fuji-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.panel = this.querySelector('.fuji-filters__panel');
      this.form = this.querySelector('form');
      if (!this.details || !this.trigger || !this.panel || !this.form) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.retainSearchOptions();
      this.priceRanges = Array.from(this.form.querySelectorAll('.fuji-filters__prices')).map(group => {
        const lower = group.querySelector('input[name$=".gte"]');
        const upper = group.querySelector('input[name$=".lte"]');
        return { lower, upper, maximum: Number(upper?.max) };
      }).filter(range => range.lower && range.upper && Number.isFinite(range.maximum));
      this.updatePriceLimits();
      for (const eventName of ['input', 'change']) {
        this.form.addEventListener(eventName, () => this.updatePriceLimits(), options);
      }
      window.addEventListener('pagehide', () => this.close(false), options);
      window.addEventListener('pageshow', () => {
        this.close(false);
        this.updatePriceLimits();
      }, options);
      this.modalFailed = false;
      const supported = typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function';
      if (!supported) return;
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'fuji-filters-modal';
      this.dialog.setAttribute('aria-labelledby', `${this.panel.id}-Title`);
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.restore();
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.close();
      }, options);
      this.trigger.addEventListener('click', event => {
        if (this.modalFailed) return;
        event.preventDefault();
        this.open();
      }, options);
      this.panel.querySelector('[data-fuji-filters-close]').addEventListener('click', () => this.close(), options);
      this.panel.querySelector('[data-fuji-filters-reset]').addEventListener('click', event => {
        if (this.modalFailed) return;
        event.preventDefault();
        for (const input of this.form.querySelectorAll('input')) {
          if (input.type === 'checkbox') input.checked = false;
          if (input.type === 'radio') input.checked = input.value === this.dataset.defaultSort;
          if (input.type === 'number') input.value = '';
          if (input.type === 'hidden' && input.name.startsWith('filter.')) input.disabled = true;
          if (input.type === 'hidden' && input.name === 'sort_by') input.value = this.dataset.defaultSort;
        }
        this.updatePriceLimits();
      }, options);
    }

    updatePriceLimits() {
      for (const { lower, upper, maximum } of this.priceRanges) {
        const minimumValue = lower.valueAsNumber;
        const maximumValue = upper.valueAsNumber;
        lower.max = Number.isFinite(maximumValue) ? Math.min(maximum, maximumValue) : maximum;
        upper.min = Number.isFinite(minimumValue) ? Math.max(0, minimumValue) : 0;
      }
    }

    retainSearchOptions() {
      const params = new URLSearchParams(window.location.search);
      for (const key of ['options[prefix]', 'options[unavailable_products]', 'type', 'view', 'fuji_search']) {
        if (!params.has(key) || this.form.querySelector('[name="view"][value="fuji-category"]')) continue;
        let input = Array.from(this.form.elements).find(element => element.name === key);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          this.form.append(input);
        }
        input.value = params.get(key);
      }
    }

    open() {
      if (!this.dialog || this.dialog.open) return;
      for (const other of document.querySelectorAll('fuji-filters')) {
        if (other !== this) other.close(false);
      }
      this.details.open = true;
      this.restoreFocus = true;
      this.dialog.append(this.panel);
      document.body.append(this.dialog);
      this.panel.querySelector('[data-fuji-filters-close]').hidden = false;
      try {
        this.dialog.showModal();
        document.body.classList.add('fuji-filters-open');
        this.trigger.setAttribute('aria-expanded', 'true');
      } catch {
        this.restore(false);
        this.modalFailed = true;
        this.trigger.removeAttribute('aria-haspopup');
        this.trigger.removeAttribute('aria-expanded');
        this.details.open = true;
      }
    }

    close(restoreFocus = true) {
      this.restoreFocus = restoreFocus;
      if (this.dialog?.open) this.dialog.close();
      this.restore(restoreFocus);
    }

    restore(restoreFocus = this.restoreFocus) {
      if (!this.dialog?.isConnected) return;
      this.details.append(this.panel);
      this.panel.querySelector('[data-fuji-filters-close]').hidden = true;
      this.details.open = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.dialog.remove();
      if (!document.querySelector('.fuji-filters-modal[open]')) document.body.classList.remove('fuji-filters-open');
      if (restoreFocus && this.isConnected) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

